import { CSS } from '@grupoboticario/flora-react'

export const headerTextCss: CSS = {
  width: '108%',
  color: '$nonInteractiveAuxiliar'
}
